import {TextField, TextFieldProps} from '@eds-web/react';
import {FieldValues, useController} from 'react-hook-form';
import {UseControllerProps} from '@/types';
import {PropsWithChildren} from 'react';
import {useLocale, useMessages} from '@epic-mw/i18n';
import {mapClientError} from '@/lib/utils/error.utils';

export type FormTextFieldProps<FormValues extends FieldValues> = UseControllerProps<
	TextFieldProps,
	FormValues
> & {
	onChange?: (e) => void;
	readOnly?: boolean;
};

export function FormTextField<FormValues extends FieldValues>({
	readOnly = false,
	name,
	rules,
	control,
	defaultValue,
	placeholder,
	shouldUnregister,
	onChange,
	...textFieldProps
}: PropsWithChildren<FormTextFieldProps<FormValues>>) {
	const messages = useMessages();
	const locale = useLocale();
	const controller = useController({
		control,
		name,
		rules,
		defaultValue,
		shouldUnregister
	});

	const {field, fieldState} = controller;
	const {error} = fieldState;
	const errorMessage =
		mapClientError(messages, error?.message || '', {locale}) || textFieldProps.error;

	return (
		<TextField
			{...textFieldProps}
			{...field}
			readOnly={readOnly}
			placeholder={placeholder || (readOnly ? '-' : '')}
			onChange={(value, e) => {
				if (typeof onChange === 'function') {
					onChange(e);
				}
				return field.onChange(e);
			}}
			error={errorMessage}
		/>
	);
}
